import React from 'react';
import MediaQueries from 'react-responsive';

import Page from 'marketing-website/components/modules/Page';
import HeroSkinny from 'marketing-website/components/modules/Hero/HeroSkinny';
import Whitespace from 'marketing-website/components/commons/Whitespace';
import Cta from 'marketing-website/components/modules/CtaStories';
import Stories from './_Stories';

const pageProps = {
  title: 'Customer Stories | Marvel',
  meta: [
    {
      name: 'description',
      content:
        "Find out how we're helping the world's most innovative companies democritise design",
    },
    { name: 'keywords', content: 'case study, customer stories' },
  ],
  header: true,
  banner: true,
  footer: true,
};

export default function CustomerStoriesMain() {
  return (
    <Page {...pageProps}>
      <HeroSkinny
        center
        tag="h1"
        maxWidth={900}
        title="Marvel helps build stronger companies by democratising design and making it more productive"
      />
      <Stories />
      <MediaQueries maxWidth={769}>
        <Whitespace size="m" />
      </MediaQueries>
      <MediaQueries minWidth={770}>
        <Whitespace size="xl" />
      </MediaQueries>
      <Cta />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/customer-stories/index.js